export default "__VITE_ASSET__CwobmqFr__"